import React from 'react';

const tupleBoxCenter = (props) => <div className={`pt-4 pb-6 pl-8 pr-4 f-fill u-flex f-column justify-content-between phone-pl-2 phone-pr-2`}>{props.children}</div>;

export default tupleBoxCenter;


// WEBPACK FOOTER //
// ./src/components/Hotel/HotelTuple/TupleBoxCenter/TupleBoxCenter.js